import { Method } from "axios";
import { ActionKeyPair, IService } from "@/shared/hooks/useCustomQuery";
import { IUser, IUserById, IUserUpdatePayload, PaginatedResponse } from "./types";
import api from "../../../../shared/api/api";

export default class ProfilesService implements IService {
  [key: string]: ActionKeyPair<unknown, unknown>;

  getProfiles: ActionKeyPair<
    {
      search?: string;
      page?: number;
      vip?: boolean;
      subscriber?: boolean;
    },
    PaginatedResponse<IUser>
  > = {
      key: "get-profiles",
      actionBuilder: (params) => async () => {
        return await api<PaginatedResponse<IUser>>({
          url: "/v1/profiles",
          method: "GET" as Method,
          params: {
            ...params,
            vip: params.vip,
            subscriber: params.subscriber
          },
        });

      },
    };
  toggleSubscription: ActionKeyPair<Omit<IUser, "id">, void> = {
    key: "toggle-subscription",
    actionBuilder: (currentUser) => async () => {
      currentUser.subscription = {
        active: !currentUser?.subscription?.active,
        expiresAt:
          currentUser.subscription?.expiresAt ?? new Date().toISOString(),
      };

      return await api({
        url: "/v1/profiles",
        method: "POST" as Method,
        data: currentUser,
      });
    },
  };


  updateUserDate: ActionKeyPair<
    {
      currentUser: IUser;
      expires_at?: string | null;
      vip_expires_at?: string | null;
    },
    void
  > = {
      key: "update-user-date",
      actionBuilder:
        ({ currentUser, expires_at, vip_expires_at }) =>
          async () => {
            if (expires_at)
              currentUser.subscription = {
                active: Boolean(currentUser.subscription?.active),
                expiresAt: expires_at,
              };

            if (vip_expires_at) currentUser["vipExpiresAt"] = vip_expires_at;

            return await api({
              url: "/v1/profiles",
              method: "POST" as Method,
              data: currentUser,
            });
          },
    };

  updateUser: ActionKeyPair<Omit<IUser, "id">, void> = {
    key: "update-user-date",
    actionBuilder: (newUserData) => async () => {
      return await api({
        url: "/v1/profiles",
        method: "POST" as Method,
        data: newUserData,
      });
    },
  };

  getProfileById: ActionKeyPair<{ id: string }, IUserById> = {
    key: "get-profile-by-id",
    actionBuilder: ({ id }) => async () => {
      return await api({
        url: `/v1/profiles/${id}`,
        method: "GET" as Method,
      });
    },
  };

  createOrUpdateProfile: ActionKeyPair<
    IUserUpdatePayload,
    void
  > = {
      key: "create-or-update-profile",
      actionBuilder: ({ email, data, avatar, cover, }) => async () => {
        const formData = new FormData();
        formData.append("data", JSON.stringify(data));


        if (avatar) formData.append("avatar", avatar);
        if (cover) formData.append("cover", cover);

        return await api({
          url: `/v1/profiles`,
          method: "POST" as Method,
          params: { email },
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      },
    };

  toggleVip: ActionKeyPair<
    { id: string, vip: boolean, vipExpiresAt: string },
    void
  > = {
      key: "toggle-vip",
      actionBuilder: ({ id, vip, vipExpiresAt }) => async () => {
        return await api({
          url: `/v1/profiles/${id}`,
          method: "PATCH" as Method,
          data: { vip, vipExpiresAt },
        });
      },
    };

  static Instance = new ProfilesService();
}
